import { useState, useEffect } from 'react';
import { Toast, Form, Table, Input, Select, Button, Space, Typography, Modal } from '@douyinfe/semi-ui';
import { IconSearch, IconEdit, IconSend, IconEyeOpened } from '@douyinfe/semi-icons';
import request from '../../utils/request';
import styles from './index.module.scss';
import React from 'react';

const { Title } = Typography;

const statusOptions = [
    { value: 0, label: '全部' },
    { value: 1, label: '待付款' },
    { value: 2, label: '待发货' },
    { value: 3, label: '已发货' },
    { value: 4, label: '已收货' },
    { value: 5, label: '已评论' },
    { value: 6, label: '维权完成' },
    { value: 8, label: '维权中' },
    { value: 10, label: '已取消' },
];

const Orders = () => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [pagination, setPagination] = useState({
        currentPage: 1,
        pageSize: 20,
        total: 0,
    });
    const [filters, setFilters] = useState({
        key: '',
        status: 0,
    });
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [currentOrder, setCurrentOrder] = useState(null);
    const [editPriceVisible, setEditPriceVisible] = useState(false);
    const [editAddressVisible, setEditAddressVisible] = useState(false);
    const [deliveryVisible, setDeliveryVisible] = useState(false);
    const [editDeliveryVisible, setEditDeliveryVisible] = useState(false);
    const [editPrice, setEditPrice] = useState('');
    const [deliveryInfo, setDeliveryInfo] = useState({ name: '', order: '' });

    const handleEditPrice = async () => {
        if (!editPrice) {
            Toast.error('请输入修改后的价格');
            return;
        }
        try {
            const res = await request.post('/go/sp/shop/edit_shop_order_price/', {
                uid: currentOrder.uid,
                paid_fee: Math.round(parseFloat(editPrice) * 100)
            });
            if (res.errno === 0) {
                Toast.success('修改价格成功');
                setEditPriceVisible(false);
                handleViewDetail(currentOrder.uid);
                fetchData();
            } else {
                Toast.error(res.errstr || '修改价格失败');
            }
        } catch (error) {
            Toast.error('修改价格失败');
        }
    };

    const handleEditAddress = async (values) => {
        try {
            const customInfo = JSON.parse(currentOrder.custom_info || '{}');
            const services = customInfo.addr?.services || [];
            const updatedServices = services.map(service => {
                if (service.addressInfo) {
                    return {
                        ...service,
                        addressInfo: {
                            ...service.addressInfo,
                            name: values.name,
                            phone: values.phone,
                            fullAddress: values.full
                        }
                    };
                }
                return service;
            });

            const res = await request.post('/go/sp/shop/edit_shop_order_custom_info/', {
                uid: currentOrder.uid,
                custom_info: JSON.stringify({
                    ...customInfo,
                    addr: {
                        ...customInfo.addr,
                        services: updatedServices
                    }
                })
            });
            if (res.errno === 0) {
                Toast.success('修改地址成功');
                setEditAddressVisible(false);
                handleViewDetail(currentOrder.uid);
                fetchData();
            } else {
                Toast.error(res.errstr || '修改地址失败');
            }
        } catch (error) {
            console.log(error)
            Toast.error('修改地址失败');
        }
    };

    const handleDelivery = async () => {
        if (!deliveryInfo.name || !deliveryInfo.order) {
            //Toast.error('请填写完整的快递信息');
            //return;
        }
        try {
            const res = await request.post('/go/sp/shop/shop_order_delivery/', {
                uid: currentOrder.uid,
                delivery_info: JSON.stringify({
                    delivery: deliveryInfo
                })
            });
            if (res.errno === 0) {
                Toast.success('发货成功');
                setDeliveryVisible(false);
                handleViewDetail(currentOrder.uid);
                fetchData();
            } else {
                Toast.error(res.errstr || '发货失败');
            }
        } catch (error) {
            Toast.error('发货失败');
        }
    };

    const handleEditDelivery = async () => {
        if (!deliveryInfo.name || !deliveryInfo.order) {
            Toast.error('请填写完整的快递信息');
            return;
        }
        try {
            const res = await request.post('/go/sp/shop/edit_shop_order_delivery_info/', {
                uid: currentOrder.uid,
                delivery_info: JSON.stringify({
                    delivery: deliveryInfo
                })
            });
            if (res.errno === 0) {
                Toast.success('修改配送信息成功');
                setEditDeliveryVisible(false);
                handleViewDetail(currentOrder.uid);
                fetchData();
            } else {
                Toast.error(res.errstr || '修改配送信息失败');
            }
        } catch (error) {
            Toast.error('修改配送信息失败');
        }
    };

    const columns = [
        {
            title: '订单信息',
            render: (_, record) => (
                <div>
                    <div style={{ marginBottom: 8, color: 'var(--semi-color-text-2)', fontSize: '12px' }}>
                        订单ID：{record.uid}
                    </div>
                    {record.products?.map((product, index) => (
                        <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: index === record.products.length - 1 ? 0 : 8 }}>
                            <img src={product.image} alt={product.title} style={{ width: 40, height: 40, objectFit: 'cover', marginRight: 8 }} />
                            <div>
                                <div>{product.title}</div>
                                {product.sku_uid && product.sku_uid.split(';', 2)[1] && (
                                    <div style={{ color: 'var(--semi-color-text-1)', fontSize: '12px' }}>
                                        {product.sku_uid.split(';').slice(1).join(' ')}
                                    </div>
                                )}
                                <div style={{ color: 'var(--semi-color-text-2)' }}>
                                    ¥{(product.price / 100).toFixed(2)} × {product.quantity}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            ),
        },
        {
            title: '买家/收货信息',
            width: 250,
            render: (_, record) => (
                <div style={{ fontSize: '12px' }}>
                    <div style={{ marginBottom: 4 }}>{record.su?.name}</div>
                    {record.custom_info && (
                        <>
                            {(() => {
                                try {
                                    const customInfo = typeof record.custom_info == 'string' ? JSON.parse(record.custom_info) : record.custom_info;
                                    return (
                                        <>
                                            {customInfo.addr && (
                                                <div style={{ color: 'var(--semi-color-text-2)' }}>
                                                    {customInfo.addr.services && customInfo.addr.services.map((service, index) => (
                                                        <div key={index} style={{ marginBottom: index < customInfo.addr.services.length - 1 ? 8 : 0 }}>
                                                            <div style={{ color: 'var(--semi-color-text-0)', marginBottom: 4 }}>{service.name}</div>
                                                            {service.addressInfo && (
                                                                <>
                                                                    <div>{service.addressInfo.name} {service.addressInfo.phone}</div>
                                                                    <div>{service.addressInfo.fullAddress}</div>
                                                                </>
                                                            )}
                                                            {service.dateTimeInfo && (
                                                                <div style={{ color: 'var(--semi-color-primary)', marginTop: 4 }}>
                                                                    预约时间：{service.dateTimeInfo.dateTime}
                                                                </div>
                                                            )}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                            {customInfo.remark && (
                                                <div style={{ color: 'var(--semi-color-danger)', marginTop: 4 }}>
                                                    备注：{customInfo.remark}
                                                </div>
                                            )}
                                        </>
                                    );
                                } catch (error) {
                                    console.error('解析 custom_info 失败:', error, record, '======');
                                    return null;
                                }
                            })()}
                        </>
                    )}
                </div>
            ),
        },
        {
            title: '实付金额',
            dataIndex: 'paid_fee',
            width: 100,
            render: (value) => `¥${(value / 100).toFixed(2)}`,
        },
        {
            title: '订单状态',
            dataIndex: 'status_text',
            width: 100,
            render: (value) => value,
        },
        {
            title: '发货信息',
            width: 200,
            render: (_, record) => {
                if (!record.delivery_info) return '-';
                try {
                    const deliveryInfo = JSON.parse(record.delivery_info);
                    return (
                        <div style={{ fontSize: '12px' }}>
                            <div>快递公司：{deliveryInfo.delivery?.name || '-'}</div>
                            <div>快递单号：{deliveryInfo.delivery?.order || '-'}</div>
                        </div>
                    );
                } catch (error) {
                    console.error('解析发货信息失败:', error);
                    return '-';
                }
            },
        },
        {
            title: '订单时间',
            width: 200,
            render: (_, record) => (
                <div style={{ fontSize: '12px' }}>
                    <div>下单：{record.create_time && record.create_time !== '0' ? new Date(parseInt(record.create_time)).toLocaleString() : '-'}</div>
                    <div>支付：{record.paid_time && record.paid_time !== '0' ? new Date(parseInt(record.paid_time)).toLocaleString() : '-'}</div>
                    <div>发货：{record.send_time && record.send_time !== '0' ? new Date(parseInt(record.send_time)).toLocaleString() : '-'}</div>
                    <div>收货：{record.recv_time && record.recv_time !== '0' ? new Date(parseInt(record.recv_time)).toLocaleString() : '-'}</div>
                </div>
            ),
        },
        {
            title: '操作',
            width: 300,
            render: (_, record) => (
                <Space>
                    {record.status === 1 && (
                        <Button type="primary" icon={<IconEdit />} onClick={() => {
                            setCurrentOrder(record);
                            setEditPriceVisible(true);
                        }}>改价</Button>
                    )}
                    {record.status < 3 && (
                        <Button type="primary" icon={<IconEdit />} onClick={() => {
                            setCurrentOrder(record);
                            setEditAddressVisible(true);
                        }}>修改地址</Button>
                    )}
                    {record.status === 2 && (
                        <Button type="primary" icon={<IconSend />} onClick={() => {
                            setCurrentOrder(record);
                            setDeliveryVisible(true);
                        }}>发货</Button>
                    )}
                    {record.status === 3 && (
                        <Button type="primary" icon={<IconEdit />} onClick={() => {
                            setCurrentOrder(record);
                            setEditDeliveryVisible(true);
                        }}>修改配送信息</Button>
                    )}
                    <Button theme="borderless" type="primary" icon={<IconEyeOpened />} onClick={() => handleViewDetail(record.uid)}>
                        查看详情
                    </Button>
                </Space>
            ),
        },
    ];

    const fetchData = async () => {
        try {
            setLoading(true);
            const res = await request.get('/go/sp/shop/list_shop_order/', {
                params: {
                    page: pagination.currentPage - 1,
                    limit: pagination.pageSize,
                    key: filters.key,
                    status: filters.status || undefined,
                },
            });
            setData(res.list || []);
            setPagination(prev => ({ ...prev, total: res.total_cnt }));
        } catch (error) {
            console.error('获取订单列表失败:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleViewDetail = async (uid) => {
        try {
            const res = await request.get('/go/sp/shop/get_shop_order/', {
                params: { uid },
            });
            if (res.errno === 0 && res.data) {
                setCurrentOrder(res.data);
                setShowDetailModal(true);
            }
        } catch (error) {
            console.error('获取订单详情失败:', error);
        }
    };

    const handleSearch = () => {
        setPagination(prev => ({ ...prev, currentPage: 1 }));
        fetchData();
    };

    const handlePageChange = (currentPage, pageSize) => {
        setPagination(prev => ({ ...prev, currentPage, pageSize }));
    };

    useEffect(() => {
        fetchData();
    }, [pagination.currentPage, pagination.pageSize]);

    return (
        <div className={styles.orderListContainer}>
            <Title heading={3} style={{ marginBottom: 24 }}>订单管理</Title>
            <div className={styles.searchBar}>
                <Input
                    prefix={<IconSearch />}
                    placeholder="搜索订单"
                    value={filters.key}
                    onChange={value => setFilters(prev => ({ ...prev, key: value }))}
                    onEnterPress={handleSearch}
                    style={{ width: 200 }}
                />
                <Select
                    placeholder="订单状态"
                    value={filters.status}
                    onChange={value => setFilters(prev => ({ ...prev, status: value }))}
                    style={{ width: 150 }}
                    optionList={statusOptions}
                />
                <Button type="primary" onClick={handleSearch}>搜索</Button>
            </div>
            <Table
                loading={loading}
                columns={columns}
                dataSource={data}
                pagination={{
                    currentPage: pagination.currentPage,
                    pageSize: pagination.pageSize,
                    total: pagination.total,
                    onPageChange: handlePageChange,
                }}
                rowKey="uid"
            />
            <Modal
                title="订单详情"
                visible={showDetailModal}
                onCancel={() => setShowDetailModal(false)}
                footer={null}
                width={800}
                bodyStyle={{ padding: '24px' }}
            >
                {currentOrder && (
                    <div className={styles.orderDetail}>
                        <div className={styles.actions}>
                            {currentOrder.status === 1 && (
                                <Button type="primary" icon={<IconEdit />} onClick={() => setEditPriceVisible(true)}>改价</Button>
                            )}
                            {currentOrder.status < 3 && (
                                <Button type="primary" icon={<IconEdit />} onClick={() => setEditAddressVisible(true)}>修改地址</Button>
                            )}
                            {currentOrder.status === 2 && (
                                <Button type="primary" icon={<IconSend />} onClick={() => setDeliveryVisible(true)}>发货</Button>
                            )}
                            {currentOrder.status === 3 && (
                                <Button type="primary" icon={<IconEdit />} onClick={() => setEditDeliveryVisible(true)}>修改配送信息</Button>
                            )}
                        </div>
                        <div className={styles.section}>
                            <h4 className={styles.sectionTitle}>基本信息</h4>
                            <div className={styles.infoGrid}>
                                <div className={styles.infoItem}>
                                    <span className={styles.label}>订单ID</span>
                                    <span className={styles.value}>{currentOrder.uid}</span>
                                </div>
                                <div className={styles.infoItem}>
                                    <span className={styles.label}>下单时间</span>
                                    <span className={styles.value}>{currentOrder.create_time && currentOrder.create_time !== '0' ? new Date(parseInt(currentOrder.create_time)).toLocaleString() : '-'}</span>
                                </div>
                                <div className={styles.infoItem}>
                                    <span className={styles.label}>支付时间</span>
                                    <span className={styles.value}>{currentOrder.paid_time && currentOrder.paid_time !== '0' ? new Date(parseInt(currentOrder.paid_time)).toLocaleString() : '-'}</span>
                                </div>
                                <div className={styles.infoItem}>
                                    <span className={styles.label}>发货时间</span>
                                    <span className={styles.value}>{currentOrder.send_time && currentOrder.send_time !== '0' ? new Date(parseInt(currentOrder.send_time)).toLocaleString() : '-'}</span>
                                </div>
                                <div className={styles.infoItem}>
                                    <span className={styles.label}>收货时间</span>
                                    <span className={styles.value}>{currentOrder.recv_time && currentOrder.recv_time !== '0' ? new Date(parseInt(currentOrder.recv_time)).toLocaleString() : '-'}</span>
                                </div>
                                <div className={styles.infoItem}>
                                    <span className={styles.label}>订单状态</span>
                                    <span className={styles.value}>{statusOptions.find(option => option.value === currentOrder.status)?.label}</span>
                                </div>
                                <div className={styles.infoItem}>
                                    <span className={styles.label}>实付金额</span>
                                    <span className={styles.value}>¥{(currentOrder.paid_fee / 100).toFixed(2)}</span>
                                </div>
                                {currentOrder.delivery_info && (
                                    <>
                                        {(() => {
                                            try {
                                                const deliveryInfo = JSON.parse(currentOrder.delivery_info);
                                                return (
                                                    <>
                                                        <div className={styles.infoItem}>
                                                            <span className={styles.label}>快递公司</span>
                                                            <span className={styles.value}>{deliveryInfo.delivery?.name || '-'}</span>
                                                        </div>
                                                        <div className={styles.infoItem}>
                                                            <span className={styles.label}>快递单号</span>
                                                            <span className={styles.value}>{deliveryInfo.delivery?.order || '-'}</span>
                                                        </div>
                                                    </>
                                                );
                                            } catch (error) {
                                                console.error('解析发货信息失败:', error);
                                                return null;
                                            }
                                        })()}
                                    </>
                                )}
                            </div>
                        </div>
                        <div className={styles.section}>
                            <h4 className={styles.sectionTitle}>买家信息</h4>
                            <div className={styles.infoGrid}>
                                <div className={styles.infoItem}>
                                    <span className={styles.label}>买家</span>
                                    <span className={styles.value}>{currentOrder.su?.name}</span>
                                </div>
                                {currentOrder.custom_info && (
                                    <>
                                        {(() => {
                                            try {
                                                const customInfo = JSON.parse(currentOrder.custom_info);
                                                return (
                                                    <>
                                                        {customInfo.addr && (
                                                            <>
                                                                {customInfo.addr.services && customInfo.addr.services.map((service, index) => (
                                                                    <React.Fragment key={index}>
                                                                        <div className={styles.infoItem}>
                                                                            <span className={styles.label}>服务名称</span>
                                                                            <span className={styles.value}>{service.name}</span>
                                                                        </div>
                                                                        {service.addressInfo && (
                                                                            <>
                                                                                <div className={styles.infoItem}>
                                                                                    <span className={styles.label}>收货人</span>
                                                                                    <span className={styles.value}>{service.addressInfo.name}</span>
                                                                                </div>
                                                                                <div className={styles.infoItem}>
                                                                                    <span className={styles.label}>联系电话</span>
                                                                                    <span className={styles.value}>{service.addressInfo.phone}</span>
                                                                                </div>
                                                                                <div className={styles.infoItem}>
                                                                                    <span className={styles.label}>收货地址</span>
                                                                                    <span className={styles.value}>{service.addressInfo.fullAddress}</span>
                                                                                </div>
                                                                            </>
                                                                        )}
                                                                        {service.dateTimeInfo && (
                                                                            <div className={styles.infoItem}>
                                                                                <span className={styles.label}>预约时间</span>
                                                                                <span className={styles.value}>{service.dateTimeInfo.dateTime}</span>
                                                                            </div>
                                                                        )}
                                                                        {index < customInfo.addr.services.length - 1 && (
                                                                            <div className={styles.divider} style={{ margin: '12px 0' }} />
                                                                        )}
                                                                    </React.Fragment>
                                                                ))}
                                                            </>
                                                        )}
                                                        {customInfo.remark && (
                                                            <div className={styles.infoItem}>
                                                                <span className={styles.label}>买家留言</span>
                                                                <span className={styles.value}>{customInfo.remark}</span>
                                                            </div>
                                                        )}
                                                    </>
                                                );
                                            } catch (error) {
                                                console.error('解析订单详情 custom_info 失败:', error);
                                                return (
                                                    <div className={styles.infoItem}>
                                                        <span className={styles.label}>自定义信息</span>
                                                        <span className={styles.value} style={{ color: 'var(--semi-color-danger)' }}>
                                                            数据格式错误
                                                        </span>
                                                    </div>
                                                );
                                            }
                                        })()}
                                    </>
                                )}
                            </div>
                        </div>
                        <div className={styles.section}>
                            <h4 className={styles.sectionTitle}>商品信息</h4>
                            <div className={styles.productList}>
                                {currentOrder.products?.map((product, index) => (
                                    <div key={index} className={styles.productItem}>
                                        <img src={product.image} alt={product.title} className={styles.productImage} />
                                        <div className={styles.productInfo}>
                                            <div className={styles.productTitle}>{product.title}</div>
                                            {product.sku_uid && product.sku_uid.split(';', 2)[1] && (
                                                <div className={styles.productSpec}>{product.sku_uid.split(';').slice(1).join(' ')}</div>
                                            )}
                                            <div className={styles.productPrice}>
                                                <span>¥{(product.price / 100).toFixed(2)}</span>
                                                <span className={styles.quantity}>× {product.quantity}</span>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}
            </Modal>

            <Modal
                title="订单改价"
                visible={editPriceVisible}
                onOk={handleEditPrice}
                onCancel={() => setEditPriceVisible(false)}
                centered
            >
                <div style={{ marginBottom: 16 }}>
                    <div style={{ marginBottom: 8 }}>原价：¥{currentOrder ? (currentOrder.paid_fee / 100).toFixed(2) : '0.00'}</div>
                    <Input
                        prefix="¥"
                        value={editPrice}
                        onChange={value => setEditPrice(value)}
                        placeholder="请输入修改后的价格"
                    />
                </div>
            </Modal>

            <Modal
                title="修改收货地址"
                visible={editAddressVisible}
                onCancel={() => setEditAddressVisible(false)}
                footer={null}
                centered
            >
                <Form onSubmit={handleEditAddress} initValues={(() => {
                    try {
                        const customInfo = JSON.parse(currentOrder?.custom_info || '{}');
                        const addressInfo = customInfo.addr?.services?.find(service => service.addressInfo)?.addressInfo || {};
                        return {
                            name: addressInfo.name || '',
                            phone: addressInfo.phone || '',
                            full: addressInfo.fullAddress || ''
                        };
                    } catch (error) {
                        console.error('解析地址信息失败:', error);
                        return {};
                    }
                })()}>
                    <Form.Input field="name" label="收货人" rules={[{ required: true, message: '请输入收货人' }]} />
                    <Form.Input field="phone" label="联系电话" rules={[{ required: true, message: '请输入联系电话' }]} />
                    <Form.Input field="full" label="收货地址" rules={[{ required: true, message: '请输入收货地址' }]} />
                    <div style={{ marginTop: 24, textAlign: 'right' }}>
                        <Button type="primary" htmlType="submit">保存</Button>
                    </div>
                </Form>
            </Modal>

            <Modal
                title="订单发货"
                visible={deliveryVisible}
                onOk={handleDelivery}
                onCancel={() => setDeliveryVisible(false)}
                centered
            >
                <Form layout="vertical">
                    <Form.Input
                        field="name"
                        label="快递公司"
                        value={deliveryInfo.name}
                        onChange={value => setDeliveryInfo(prev => ({ ...prev, name: value }))}
                        placeholder="请输入快递公司名称"
                    />
                    <Form.Input
                        field="order"
                        label="快递单号"
                        value={deliveryInfo.order}
                        onChange={value => setDeliveryInfo(prev => ({ ...prev, order: value }))}
                        placeholder="请输入快递单号"
                    />
                </Form>
            </Modal>

            <Modal
                title="修改配送信息"
                visible={editDeliveryVisible}
                onOk={handleEditDelivery}
                onCancel={() => setEditDeliveryVisible(false)}
                centered
            >
                <Form layout="vertical">
                    <Form.Input
                        field="name"
                        label="快递公司"
                        value={deliveryInfo.name}
                        onChange={value => setDeliveryInfo(prev => ({ ...prev, name: value }))}
                        placeholder="请输入快递公司名称"
                        initValue={(() => {
                            try {
                                return currentOrder?.delivery_info ? JSON.parse(currentOrder.delivery_info).delivery?.name : '';
                            } catch (error) {
                                return '';
                            }
                        })()}
                    />
                    <Form.Input
                        field="order"
                        label="快递单号"
                        value={deliveryInfo.order}
                        onChange={value => setDeliveryInfo(prev => ({ ...prev, order: value }))}
                        placeholder="请输入快递单号"
                        initValue={(() => {
                            try {
                                return currentOrder?.delivery_info ? JSON.parse(currentOrder.delivery_info).delivery?.order : '';
                            } catch (error) {
                                return '';
                            }
                        })()}
                    />
                </Form>
            </Modal>
        </div>
    );
};

export default Orders;